import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CrossSell({ slug }) {
  const [items, setItems] = useState([]);
  const { fmt, lang } = useApp() || {};

  useEffect(() => {
    if (!slug) return;
    axios.get(`${API}/products/${slug}/cross-sell?limit=4`).then((r) => {
      setItems(r.data?.items || []);
    }).catch(() => setItems([]));
  }, [slug]);

  if (!items.length) return null;
  return (
    <section className="py-12 border-t border-ink/10" data-testid="cross-sell-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <p className="text-xs uppercase tracking-[0.25em] text-ink/60 mb-3">Maillage clinique</p>
        <h2 className="font-display text-2xl md:text-3xl mb-2">Outils complémentaires pour orthophonistes</h2>
        <p className="text-sm text-ink-soft mb-8 max-w-2xl">Autres jeux et matériel d&apos;orthophonie fréquemment associés à cette ressource en séance de rééducation.</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((p) => {
            const name = (typeof p.name === "object" ? (p.name[lang] || p.name.fr || p.name.en) : p.name) || "";
            const img = (p.images && p.images[0]) || null;
            return (
              <Link
                key={p.id}
                to={`/produit/${p.slug}`}
                data-testid={`cross-sell-item-${p.slug}`}
                className="group block bg-white rounded-xl overflow-hidden border border-ink/5 hover:shadow-md transition"
              >
                <div className="aspect-square bg-ivory-200">
                  {img ? <img src={img} alt={name} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition" /> : null}
                </div>
                <div className="p-3">
                  <p className="text-sm line-clamp-2 group-hover:text-coral">{name}</p>
                  <p className="text-sm font-medium mt-2">{fmt ? fmt(p.price) : `${p.price} €`}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
